import type { AxiosInstance } from 'axios';

import { MissingNodeApiClientError } from './errors';

let nodeApiAxiosInstance: AxiosInstance | null = null;

export const registerNodeApiAxiosInstance = ({ instance }: { instance: AxiosInstance }) => {
  nodeApiAxiosInstance = instance;
};

export const getNodeApiAxiosInstance = (): AxiosInstance => {
  if (!nodeApiAxiosInstance) {
    throw new MissingNodeApiClientError();
  }

  return nodeApiAxiosInstance;
};
